import * as React from 'react';
import MUICheckbox, { CheckboxProps } from '@mui/material/Checkbox';
import cn from 'classnames';

import { useTheme } from '../../../theme';

const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(({ className, required, ...restProps }, ref) => {
	const { Checkbox: css } = useTheme('BaseComponents');

	return (
		<MUICheckbox
			ref={ref}
			classes={{
				root: cn(css.checkbox, className, { [css.required]: required }),
				checked: css.checked,
				disabled: css.disabled,
				indeterminate: css.indeterminate
			}}
			{...restProps}
		/>
	);
});

export default Checkbox;
